const PerformanceMetrics = {
  name: 'PerformanceMetrics',
  type: 'object',
  properties: {
    Impressions: {
      type: 'integer',
      nullable: true,
    },
    Clicks: {
      type: 'integer',
      nullable: true,
    },
    CTR: {
      type: 'number',
      nullable: true,
    },
    Conversions: {
      type: 'integer',
      nullable: true,
    },
    Spend: {
      type: 'number',
      nullable: true,
    },
    AverageCPC: {
      type: 'number',
      nullable: true,
    },
    AveragePosition: {
      type: 'number',
      nullable: true,
    },
    AverageCPM: {
      type: 'number',
      nullable: true,
    },
    CPA: {
      type: 'number',
      nullable: true,
    },
    WebsiteCoverage: {
      type: 'number',
      nullable: true,
    },
    AuctionWonPercent: {
      type: 'number',
      nullable: true,
      sovcolumn: true,
      isPercentValue: true,
    },
    AuctionLostToBudgetPercent: {
      type: 'number',
      nullable: true,
      sovcolumn: true,
      isPercentValue: true,
    },
    AuctionLostToRankPercent: {
      type: 'number',
      nullable: true,
      sovcolumn: true,
      isPercentValue: true,
    },
    AuctionLostToLandingPercent: {
      type: 'number',
      nullable: true,
      sovcolumn: true,
      isPercentValue: true,
    },
    AuctionLostToAdQualityPercent: {
      type: 'number',
      nullable: true,
      sovcolumn: true,
      isPercentValue: true,
    },
    AuctionLostToBidPercent: {
      type: 'number',
      nullable: true,
      sovcolumn: true,
      isPercentValue: true,
    },
    ClickSharePercent: {
      type: 'number',
      nullable: true,
    },
    RevenueOnAdSpend: {
      type: 'number',
      nullable: true,
    },
    AdvertiserReportedRevenue: {
      type: 'number',
      nullable: true,
    },
    ConversionRate: {
      type: 'number',
      nullable: true,
    },
  },
};

const Labels = {
  type: 'array',
  items: {
    type: 'object',
    schema: {
      name: 'Label',
      type: 'object',
      key: 'Id',
      properties: {
        Id: {
          type: 'integer',
          key: true,
          nullable: true,
        },
        Name: {
          type: 'string',
          maxLength: 80,
          required: true,
        },
        Description: {
          type: 'string',
          maxLength: 200,
        },
        ColorCode: {
          type: 'integer',
          nullable: true,
        },
        AssociationCounts: {
          type: 'object',
          schema: {
            name: 'LabelAssociationCounts',
            type: 'object',
            properties: {
              CampaignCount: {
                type: 'integer',
              },
              AdGroupCount: {
                type: 'integer',
              },
              AdCount: {
                type: 'integer',
              },
              KeywordCount: {
                type: 'integer',
              },
            },
          },
        },
      },
    },
  },
  isRelatedEntity: true,
  filterable: true,
};

export const mockSchema = {
  name: 'Campaign',
  type: 'object',
  key: 'Id',
  required: ['Name'],
  properties: {
    Id: {
      filterable: true,
      skipLocalization: true,
      type: 'integer',
      key: true,
    },
    Name: {
      type: 'string',
      filterable: true,
    },
    Status: {
      type: 'string',
      enum: ['Active', 'Deleted', 'Suspended', 'UserPaused', 'BudgetPaused', 'BudgetUserPaused'],
      filterable: true,
    },
    Budget: {
      filterable: ['Amount'],
      schema: {
        key: 'Id',
        name: 'Budget',
        properties: {
          Id: {
            type: 'integer',
            key: true,
            nullable: true,
          },
          Name: {
            type: 'string',
            filterable: true,
          },
          Amount: {
            type: 'number',
          },
        },
      },
    },
    CampaignType: {
      chooseType: 'checkbox',
      type: 'string',
      enum: ['Default', 'Shopping', 'Audience'],
      filterable: true,
    },
    Languages: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    DeliveryStatus: {
      chooseType: 'checkbox',
      type: 'string',
      enum: ['CreditCardExpired', 'IOExceeded', 'PaymentInformationMissing', 'InvalidFinancialStatusOther', 'MigrationPaused', 'CampaignDeleted', 'CampaignSuspended', 'CampaignBudgetPaused', 'DomainLanguageNotSupported', 'ShoppingCampaignStoreNotFound', 'ShoppingCampaignNoOffersPresent', 'AdGroupExpired', 'AdGroupDraft', 'AdGroupDeleted', 'CamAssetRejected', 'CamAssetDeleted', 'AdGroupTargetingTooNarrow', 'EditorialRejected', 'EditorialUnderAppeal', 'UrlInvalid', 'ApplicationNotFound', 'ApplicationDestinationUrlMismatch', 'PendingMetadataSync', 'EditorialPending', 'AssociationDeleted', 'CampaignUserPaused', 'AdGroupPrivacyPending', 'AdGroupUserPaused', 'AdUserPaused', 'KeywordMatchTypeAdGroupMediumCombinationInvalid', 'KeywordUserPaused', 'NegativeKeywordConflicts', 'PartialNegativeKeywordConflicts', 'AutoBiddingLimitedByNotEnoughConversions', 'EditorialApprovedLimited', 'LowSupply', 'LowQuality', 'BidBelowFirstPageBid', 'Incomplete', 'BudgetSuggestions', 'InlineOpportunity', 'GeoCodingIncomplete', 'ProductTargetUserPaused', 'AdExtensionNotPresent', 'AdExtensionDeleted', 'AdExtensionAssociationDeleted', 'StoreIdNotAssociated', 'AdGroupAudienceAssociationPaused', 'AdGroupAudienceAssociationExcluded', 'AdNotPresent', 'AdNotActive', 'ApplicationDestinationUrlValidationIncomplete', 'AdGroupCriterionExcluded', 'AdGroupCriterionPaused', 'Eligible'],
      filterable: true,
    },
    PerformanceMetrics: {
      type: 'object',
      schema: PerformanceMetrics,
      filterable: ['Impressions', 'Clicks', 'CTR', 'Spend', 'Conversions',
        'AverageCPC', 'AverageCPM', 'AveragePosition', 'CPA', 'RevenueOnAdSpend',
        'ConversionRate', 'AdvertiserReportedRevenue'],
      alias: {
        Spend: {
          legacy: 'TotalEffectiveCost',
        },
      },
    },
    Labels,
    PhonePerformanceMetrics: {
      type: 'object',
      $schema: {},
    },
    QualityScore: {
      type: 'object',
      $schema: {},
    },
    UpdatedOnLastImport: {
      type: 'boolean',
    },
    HasAuctionInsight: {
      type: 'boolean',
      filterable: true,
    },
    TrackingUrlTemplate: {
      type: 'string',
    },
    UrlCustomParameters: {
      type: 'array',
      items: {
        type: 'object',
        $schema: {},
      },
    },
    BiddingScheme: {
      type: 'object',
      $schema: {},
    },
    NativeBidAdjustment: {
      type: 'integer',
      nullable: true,
    },
    DisplayBiddingStrategyType: {
      type: 'string',
      enum: ['InheritFromParent', 'ManualCpc', 'MaxClicks', 'MaxConversions', 'TargetCpa', 'EnhancedCpc'],
    },
    DisplayBiddingStrategyMaxCpc: {
      type: 'number',
      nullable: true,
    },
    DisplayBiddingStrategyTargetCpa: {
      type: 'number',
      nullable: true,
    },
    DsaTargets: {
      type: 'array',
      items: {
        type: 'object',
        $schema: {},
      },
    },
    DomainCategorys: {
      type: 'array',
      items: {
        type: 'object',
        $schema: {},
      },
    },
    NegativeAdGroupDsaTargets: {
      type: 'array',
      items: {
        type: 'object',
        $schema: {},
      },
    },
    Categories: {
      type: 'array',
      items: {
        type: 'object',
        $schema: {},
      },
    },
    DsaSearchTerms: {
      type: 'array',
      items: {
        type: 'object',
        $schema: {},
      },
    },
  },
};

export const mockLabelSchema = {
  name: 'Label',
  type: 'object',
  key: 'Id',
  properties: {
    Id: {
      type: 'integer',
      key: true,
      nullable: true,
    },
    Name: {
      type: 'string',
      maxLength: 80,
      required: true,
    },
    Description: {
      type: 'string',
      maxLength: 200,
    },
    ColorCode: {
      type: 'integer',
      nullable: true,
    },
    AssociationCounts: {
      type: 'object',
      $schema: {
        name: 'LabelAssociationCounts',
        type: 'object',
        properties: {
          CampaignCount: {
            type: 'integer',
          },
          AdGroupCount: {
            type: 'integer',
          },
          AdCount: {
            type: 'integer',
          },
          KeywordCount: {
            type: 'integer',
          },
        },
      },
    },
  },
};
